import { LIST_NOTIFICATIONS, UNREAD_NOTIFICATION_COUNT } from '@/constants/api'
import {
	InfiniteData,
	Updater,
	useQuery,
	UseQueryOptions,
	UseSuspenseInfiniteQueryOptions,
} from '@tanstack/react-query'
import queryClient from '../queryClient'
import { get, post } from '../request'

export const UNREAD_NOTIFICATION_COUNT_QUERY_OPTIONS: UseQueryOptions<number> = {
	queryKey: [UNREAD_NOTIFICATION_COUNT],
	queryFn: () => get(UNREAD_NOTIFICATION_COUNT).then((res) => res.data.unreadCount),
	initialData: 0,
	placeholderData: 0,
}

interface QueryNotificationsPage {
	data: Notification[]
	loadMoreKey?: unknown
}
export const NOTIFICATIONS_QUERY_OPTIONS: UseSuspenseInfiniteQueryOptions<
	QueryNotificationsPage,
	unknown,
	InfiniteData<QueryNotificationsPage>
> = {
	queryKey: [LIST_NOTIFICATIONS],
	queryFn: ({ pageParam }) =>
		post<QueryNotificationsPage>(LIST_NOTIFICATIONS, {
			limit: 20,
			loadMoreKey: pageParam,
		}).then((res) => {
			const body = res.data

			return body
		}),
	getNextPageParam: (lastPage: QueryNotificationsPage) => lastPage.loadMoreKey,
	initialPageParam: undefined,
	refetchOnMount: false,
	refetchOnWindowFocus: false,
	refetchOnReconnect: false,
	retryOnMount: false,
}

export const IS_NOTI_ALLOWED_QUERY_OPTIONS_KEY = ['IS_NOTI_ALLOWED']
export function getIsNotiAllowed() {
	return queryClient.getQueryData<boolean>(IS_NOTI_ALLOWED_QUERY_OPTIONS_KEY)
}
export function setIsNotiAllowed(updater: Updater<boolean, boolean>) {
	return queryClient.setQueryData<boolean>(
		IS_NOTI_ALLOWED_QUERY_OPTIONS_KEY,
		updater as Updater<boolean | undefined, boolean | undefined>
	)
}
export function useIsNotiAllowed() {
	const { data } = useQuery<boolean>({
		queryKey: IS_NOTI_ALLOWED_QUERY_OPTIONS_KEY,
		initialData: 'Notification' in window && globalThis.Notification.permission === 'granted',
	})
	return [data, setIsNotiAllowed] as const
}
